import { VueModule } from '@Foundation/utilities';
import Captcha from './code/Scripts/components/captcha.vue';

export default VueModule({
  components: {
    Captcha
  }
});
